export const evaluationOfModels = [
  {
    id: 'conflicting-viewpoints',
    title: 'Comparing Conflicting Viewpoints',
    description: 'Analyze and compare competing scientific hypotheses, theories, or perspectives',
    passages: [
      {
        id: 1,
        title: 'Dinosaur Extinction: Two Theories',
        difficulty: 'Medium',
        contentArea: 'Earth Science',
        passage: 'Scientist 1: Asteroid impact caused rapid climate change. Scientist 2: Volcanic activity caused gradual environmental changes over thousands of years.',
        data: 'Evidence supporting each theory',
        questions: [
          'What is the main difference between the two theories?',
          'Which theory suggests a faster extinction timeline?',
          'What evidence would support Scientist 1?'
        ]
      },
      {
        id: 2,
        title: 'Origin of the Moon',
        difficulty: 'Hard',
        contentArea: 'Earth Science',
        passage: 'Theory A: Moon formed from debris after Earth collision. Theory B: Moon was captured by Earth\'s gravity. Theory C: Moon formed alongside Earth.',
        data: 'Predictions and evidence for each theory',
        questions: [
          'Which theory best explains Moon\'s similar composition to Earth?',
          'What observation would disprove Theory B?',
          'Compare the timelines proposed by each theory'
        ]
      }
    ]
  },
  {
    id: 'evaluating-hypotheses',
    title: 'Evaluating Hypotheses with New Evidence',
    description: 'Determine which hypothesis is supported or refuted by new experimental data',
    passages: [
      {
        id: 1,
        title: 'Plant Growth Hormone Hypothesis',
        difficulty: 'Medium',
        contentArea: 'Biology',
        passage: 'Hypothesis: Auxin promotes root growth. Experiment: Plants treated with auxin showed 40% more root mass than control plants.',
        data: 'Experimental results table',
        questions: [
          'Does the data support the hypothesis?',
          'What would refute this hypothesis?',
          'What additional experiment would strengthen the conclusion?'
        ]
      },
      {
        id: 2,
        title: 'Reaction Rate and Temperature',
        difficulty: 'Medium',
        contentArea: 'Chemistry',
        passage: 'Hypothesis: Doubling temperature doubles reaction rate. Data showed rate increased 4x when temperature doubled from 20°C to 40°C.',
        data: 'Graph showing temperature vs. rate',
        questions: [
          'Is the hypothesis supported?',
          'What is the actual relationship?',
          'How should the hypothesis be revised?'
        ]
      }
    ]
  },
  {
    id: 'drawing-conclusions',
    title: 'Drawing Conclusions from Data',
    description: 'Make valid inferences and conclusions based on experimental results',
    passages: [
      {
        id: 1,
        title: 'Antibiotic Resistance in Bacteria',
        difficulty: 'Medium',
        contentArea: 'Biology',
        passage: 'Bacteria were exposed to increasing antibiotic concentrations. After 20 generations, bacteria survived 10x higher concentrations than initially.',
        data: 'Multi-generation survival data',
        questions: [
          'What can be concluded about the bacteria?',
          'What mechanism likely caused this change?',
          'Can we conclude the antibiotic is ineffective?'
        ]
      },
      {
        id: 2,
        title: 'Coral Bleaching and Ocean Temperature',
        difficulty: 'Hard',
        contentArea: 'Biology',
        passage: 'Coral reefs in warmer waters showed 60% bleaching while cooler reefs showed 10% bleaching. Both had similar water quality.',
        data: 'Temperature vs. bleaching percentage',
        questions: [
          'What conclusion can be drawn?',
          'Can we conclude temperature causes bleaching?',
          'What confounding variables should be considered?'
        ]
      }
    ]
  },
  {
    id: 'identifying-assumptions',
    title: 'Identifying Assumptions and Limitations',
    description: 'Recognize unstated assumptions and limitations in scientific arguments and experiments',
    passages: [
      {
        id: 1,
        title: 'Carbon Dating of Fossils',
        difficulty: 'Hard',
        contentArea: 'Earth Science',
        passage: 'Scientists used carbon-14 dating to determine a fossil is 50,000 years old. They assumed carbon-14 decay rate has remained constant.',
        data: 'Dating methodology description',
        questions: [
          'What assumption is being made?',
          'What would happen if the assumption is false?',
          'What is a limitation of this dating method?'
        ]
      },
      {
        id: 2,
        title: 'Drug Testing on Mice',
        difficulty: 'Hard',
        contentArea: 'Biology',
        passage: 'A drug reduced tumor size by 80% in mice. Researchers concluded it would be effective in humans.',
        data: 'Study results and conclusions',
        questions: [
          'What assumption is made about mice and humans?',
          'What are limitations of this conclusion?',
          'What additional studies are needed?'
        ]
      }
    ]
  },
  {
    id: 'theory-support',
    title: 'Determining Which Theory is Better Supported',
    description: 'Evaluate which competing theory has stronger evidence or makes better predictions',
    passages: [
      {
        id: 1,
        title: 'Light: Wave vs. Particle',
        difficulty: 'Hard',
        contentArea: 'Physics',
        passage: 'Wave theory explains interference patterns. Particle theory explains photoelectric effect. New experiment shows both behaviors.',
        data: 'Evidence for each theory',
        questions: [
          'Which theory is better supported overall?',
          'Can both theories be partially correct?',
          'What does the new evidence suggest?'
        ]
      },
      {
        id: 2,
        title: 'Continental Drift vs. Expanding Earth',
        difficulty: 'Hard',
        contentArea: 'Earth Science',
        passage: 'Theory 1: Continents drift on tectonic plates. Theory 2: Earth is expanding, pushing continents apart. Seafloor spreading data was discovered.',
        data: 'Multiple lines of evidence',
        questions: [
          'Which theory does seafloor spreading support?',
          'What evidence would support expanding Earth?',
          'Why is Theory 1 more widely accepted?'
        ]
      }
    ]
  }
];